import React from "react";
import Slider from "react-slick";

import App18 from "../images/PLAYBOXTV (2).png";
import App3 from "../images/new_Jiohotstar.jpeg";
import App4 from "../images/new_Sonyliv.jpeg";
import App5 from "../images/new_Zee5.jpeg";
import App25 from "../images/FW ott logo.png";
import App6 from "../images/new_Chaupal.jpeg";
import App7 from "../images/new_fancode.jpeg";
import App9 from "../images/new_stage.jpeg";
import App16 from "../images/new_discovery.jpeg";
import App8 from "../images/OMTV.png";
import App20 from "../images/chanajor.png";
import App10 from "../images/new_Sheemaro.webp";
import App11 from "../images/KANCHA.png";
import App12 from "../images/ITAP.png";
import App13 from "../images/DANGAL.png";
import App14 from "../images/WAVES.png";
import App22 from "../images/travel.png";
import App24 from "../images/etv.png";
import App15 from "../images/new_shortstv.jpeg";
import App99 from "../images/RUnn.png";
import App89 from "../images/new_Hungama_Paly.png";

export const OttsliderNew = ({ price, pname, features }) => {
  const settings2 = {
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    speed: 300,
  };

  const planName = pname?.toUpperCase() || "";

  const apps = [
    { img: App25, key: "FW ott logo" },
    { img: App18, key: "playbox" },
    { img: App3, key: "jiohotstar" },
    { img: App4, key: "sony" },
    { img: App5, key: "zee" },
    { img: App6, key: "chaupal" },
    { img: App7, key: "fancode" },
    { img: App16, key: "discovery" },
    { img: App20, key: "chanajor" },
    { img: App10, key: "sheemaro" },
    { img: App9, key: "stage" },
    { img: App8, key: "omtv" },
    { img: App11, key: "kancha" },
    { img: App12, key: "itap" },
    { img: App13, key: "dangal" },
    { img: App14, key: "waves" },
    { img: App15, key: "new_shortstv" },
    { img: App22, key: "travel" },
    { img: App24, key: "etv" },
    { img: App99, key: "RUnn" },
    { img: App89, key: "hungama" },
  ];
  const filteredApps = apps.filter((app) => {
    // ❌ Remove FW OTT for these plans
    if (
      ["498", "598", "798", "849", "898", "998", "1248", "1498"].includes(
        String(price),
      ) &&
      app.key === "FW ott logo"
    ) {
      return false;
    }

    // ❌ Remove Discovery + Waves + ETV only for 549
    if (
      String(price) === "549" &&
      ["discovery", "waves", "etv"].includes(app.key)
    ) {
      return false;
    }

    // ❌ Remove Hotstar + RUnn + Hungama for 649 Cable Bonanza
    if (
      String(price) === "649" &&
      planName.includes("CABLE") &&
      ["jiohotstar", "RUnn", "hungama"].includes(app.key)
    ) {
      return false;
    }

    // ❌ Remove Hotstar + RUnn + Hungama for 798 Gold HD
    if (
      String(price) === "798" &&
      features?.includes("GOLD HD") &&
      !features?.includes("text-transform:none") &&
      ["jiohotstar", "RUnn", "hungama"].includes(app.key)
    ) {
      return false;
    }

    return true;
  });

  return (
    <div className="ottslider">
      <Slider {...settings2}>
        {filteredApps.map((app, index) => (
          <div key={index}>
            <div className="ottimg">
              <img src={app.img} alt={app.key} />
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};
